module.exports = __webpack_public_path__ + "img/colegiobautista_alto_parana.f8136f7f.png";